<template>
  <div class="containers">
    <!-- 更改浏览器标题 -->
    <!-- <div class="main" v-title data-title="首页">
    </div> -->
    <!-- 轮播 -->
    <!-- <Swiper></Swiper> -->
    <div class="max">
      <h3>加入我们</h3>
      <p>天海融合防务装备技术股份有限公司</p>
      <img src="../assets/imgs/企业概况/02.png" alt="" class="img" style="padding: 0"/>
    </div>
  </div>
</template>
<script>
// import Swiper from './components/swiper.vue'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      num: 1
    }
  },
  components: {
    // Swiper
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
    })
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.containers {
  box-sizing: border-box;
  min-width: 1200px;
  padding-top: 60px;
  background-color: #112945;
  // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);

  box-sizing: border-box;
  @media screen and (min-width: 1200px) {
      padding-top: 120px;
  }

  /deep/.today .cell {
    color: #333 !important;
    font-weight: 500 !important;
  }
  .img {
    width: 1239px;
  }
  .max {
    width: 1200px;
    margin: 40px auto;
    height: calc(100vh - 500px);
    // padding-bottom: 250px;
    text-align: center;
    @media screen and (max-width: 1200px) {
      padding-top: 60px;
    }
    h3 {
      font-size: 32px;
      color: #fff;
      margin-bottom: 20px;
    }
    p {
      font-size: 20px;
      color: #fff;
      width: 670px;
      margin: 0 auto;
      text-align: center;
      line-height: 26px;
      @media screen and (max-width: 1200px) {
        line-height: 52px;
      }
    }
  }
}
</style>
